const ACTIVATE_PLATFORM_OWNER_URL =
  "https://us-central1-manucalc-1d2b5.cloudfunctions.net/activatePlatformOwner";

const AUTHORITATIVE_PLATFORM_OWNER_UIDS = [
  "3ldnambcSSOSEz5XDw99BNDhfEq2",
  "HU3jvpJOkDgaFa2SHjLWrRxfk9a2",
  "M9UBsiCLjCVnzxRvSKCJ6N4QJ5C3",
];

const PLATFORM_OWNER_UIDS = new Set(
  [
    ...AUTHORITATIVE_PLATFORM_OWNER_UIDS,
    ...String(process.env.REACT_APP_PLATFORM_OWNER_UIDS || "")
    .split(",")
    .map((uid) => uid.trim())
    .filter(Boolean),
  ]
);

export const isKnownPlatformOwnerUid = (uid) => PLATFORM_OWNER_UIDS.has(uid);

export const ensurePlatformOwnerClaim = async (user, currentTokenResult) => {
  if (!user?.uid) return false;
  if (currentTokenResult?.claims?.platformOwner === true) return true;
  if (!isKnownPlatformOwnerUid(user.uid)) return false;

  const idToken = await user.getIdToken();
  const response = await fetch(ACTIVATE_PLATFORM_OWNER_URL, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Content-Type": "application/json",
    },
  });

  if (response.status === 403) return false;
  if (!response.ok) {
    throw new Error("Platform-owner access could not be activated.");
  }

  const refreshedToken = await user.getIdTokenResult(true);
  return refreshedToken.claims.platformOwner === true;
};
